module.exports = __webpack_public_path__ + "static/media/line.fd5513e7.svg";